import f from "../../funcs";
import $ from "jquery";
import Api from "./Api";
import RowsStorage from "../storage/RowsStorage";
import UIModal from "../modals/UIModal";
import langDictionary from "../lang/init";
import ApiError from "../Error/ApiError";
import "../../plugins/jquery.cookie";


// TODO: привести все callback'и в общий вид (err, model)
let SYS_FILES = RowsStorage.get("SYS_FILES");

let FilesApi = Api.extend("FilesApi", {
    _entity: "table",
    limit: 10
});

FilesApi.prototype.init = function(params) {
    params = params || {};
    FilesApi.__super__.init.apply(this, arguments);

    this.table = params.table;
    this.limit = params.limit || this.limit;
};

// callback(err, rows)
FilesApi.prototype.uploadFiles = function(files, callback, onProgress) {
    return FilesApi.uploadFiles(files, callback, onProgress);
};

// callback(err, rows)
FilesApi.uploadFiles = function(files, callback, onProgress) {

    let IS_GLOBAL = 0;
    let parentId = null;
    let params = {};
    let onUploadProgress;

    if ( f.isFile(files) ) {
        files = [files];
    }
    if ( f.isFileList(files) ) {
        files = {
            files,
            callback,
            onProgress
        };
    }

    let target;
    if ( f.isObject(files) ) {
        params = files;
        files = params.files;

        if ( !f.isFunction(callback) ) {
            callback = params.callback;
        }

        onProgress = params.onProgress;
        onUploadProgress = params.onUploadProgress;
        IS_GLOBAL = "isGlobal" in params ? +!!params.isGlobal : 0;
        parentId = "parentId" in params ? params.parentId : null;

        target = "target" in params ? params.target : null;
    }

    f.ajaxSend({
        initAbort: params.initAbort,
        url: "api/files/upload",
        onProgress,
        onUploadProgress,
        headers: {
            Autorization: $.cookie("token")
        },
        data: {
            files,
            target
        },
        onError(xhr) {
            let response = xhr.responseText;
            try {
                response = JSON.parse(response);
                // небольшой костыль
                if ( response.error && response.message ) {
                    response.error = response.message;
                }
            } catch (e) {
                response = { status: "error", message: "unknown_error" };
            }

            if ( params.showError !== false ) {
                return callback(response);
            } else {
                return callback(new ApiError({ response }));
            }
        },
        onSuccess(response) {
            // обработка экстремальных ошибок
            if ( !f.isObject(response) || !f.isObject(response.result) || !f.isArray(response.result.files) ) {
                if ( f.isObject(response) ) {
                    if ( params.showError === false ) {
                        return callback(response);
                    } else {
                        return callback(new ApiError({ response }));
                    }
                } else {
                    if ( params.showError !== false ) {
                        UIModal.error(langDictionary.get("unknown_error"));
                    }
                    return callback({ status: "error", code: "unknown_error" });
                }
            }

            let result = response.result;
            // обработка типичной ошибки
            if ( result.status != "success" ) {
                if ( params.showError !== false ) {
                    UIModal.error(langDictionary.get(result.code));
                }
                return callback(result);
            }

            let resFiles = result.files || [];
            let resFile;

            // если сервер вернул не все файлы, то автозаполняем ошибками
            const toMeta = [];
            let name;
            let ext;
            let file;
            let url;
            for (let i = 0, n = files.length; i < n; i++) {
                resFile = resFiles[i];
                file = files[i];

                if ( !f.isObject(resFile) ) {
                    continue;
                }

                name = resFile.name.split(/\.\w+$/)[0];
                ext = resFile.name.split(".");
                url = resFile.url;

                if ( ext.length === 0 ) {
                    ext = "";
                } else {
                    ext = ext.pop();
                }

                toMeta.push({
                    FILE_NAME: name,
                    FILE_EXT: ext,
                    FILE_SIZE: file.size,
                    FILE_URL: url,
                    IS_GLOBAL,
                    ID_SYS_FILES: parentId,
                    ID_LIST_USER: system.user.id
                });
            }

            // TODO: передать параметр
            // showError: false
            FilesApi.createMetaFiles(toMeta, callback);
        }
    });
};

// callback(err, models)
FilesApi.getFromSysFolder = function(params, callback) {
    if ( f.isString(params) ) {
        params = {
            local: true,
            sysName: params
        };
    }
    params = f.deepMixin({
        local: true,
        sysName: ""
    }, params);

    let sysName = params.sysName;
    let filter = {
        sysName: {
            type: "equal",
            key: "SYS_NAME",
            value: sysName
        }
    };
    if ( params.local ) {
        filter.user = {
            type: "equal",
            key: "ID_LIST_USER",
            value: system.user.id
        };
    } else {
        filter.glob = {
            type: "equal",
            key: "IS_GLOBAL",
            value: 1
        };
    }

    SYS_FILES.get({
        limit: 1,
        filter: SYS_FILES.Filter(["AND"].concat(Object.keys(filter)), filter)
    }, function(err, folders) {
        if ( err || !folders || !folders.length ) {
            return callback(err, []);
        }

        SYS_FILES.get(SYS_FILES.Filter(["AND", "fid"], {
            fid: {
                type: "equal",
                key: "ID_SYS_FILES",
                value: folders[0].id
            }
        }), callback);
    });
};

// callback(err, rows)
FilesApi.uploadToSysFolder = function(params, callback) {
    params = f.deepMixin({
        // флаг local определяет будет ли системная папка привязана к текущему юзеру,
        // если нет, то эта папка доступна всем
        local: true,

        sysName: "",
        files: []
    }, params);

    let files = params.files;
    let sysName = params.sysName;
    let scope = {};
    let paste2scope = function(key, next, err, value) {
        scope[key] = value;
        next(err, value);
    };

    f.series([
        function(next) {
            let filter = {
                sysName: {
                    type: "equal",
                    key: "SYS_NAME",
                    value: sysName
                }
            };

            if ( params.local ) {
                filter.user = {
                    type: "equal",
                    key: "ID_LIST_USER",
                    value: system.user.id
                };
            } else {
                filter.glob = {
                    type: "equal",
                    key: "IS_GLOBAL",
                    value: 1
                };
            }

            // пробуем найти папку с таким именем
            SYS_FILES.get({
                limit: 1,
                filter: SYS_FILES.Filter(["AND"].concat(Object.keys(filter)), filter)
            }, paste2scope.bind(null, "folderModels", next));
        },
        // если ее нет и ее нужно создать, то создаем
        function(next) {
            if ( scope.folderModels && scope.folderModels.length ) {
                scope.folderModel = scope.folderModels[0];
                return next(null);
            }

            let row = {
                SYS_NAME: sysName
            };
            if ( !params.local ) {
                row.IS_GLOBAL = 1;
            } else {
                row.ID_LIST_USER = system.user.id;
            }

            SYS_FILES.create(row, paste2scope.bind(null, "folderModel", next));
        },
        function(next) {
            if ( !scope.folderModel ) {
                return next(new Error("system folder not found and not created"));
            }

            FilesApi.uploadFiles({
                initAbort: params.initAbort,
                onUploadProgress: params.onUploadProgress,
                onProgress: params.onProgress,
                files,
                IS_GLOBAL: !params.local,
                parentId: scope.folderModel.id
            }, paste2scope.bind(null, "files", next));
        }
    ], function(err) {
        callback(err, scope.files);
    });
};

// ОСТОРОЖНО!!! может быть синхронно
// callback(err, rows)
FilesApi.createMetaFiles = function(files, callback) {
    if ( !callback ) {
        callback = function() {};
    }

    if ( files.length === 0 ) {
        return callback(null, []);
    }

    SYS_FILES.createRows(files, function(err, models) {
        if ( err ) {
            return callback(err, []);
        }

        callback(null, models.map(function(model) {
            return model.getTexts();
        }));
    });
};

// callback(row)
FilesApi.loadFile = function(id, callback) {
    if ( !callback ) {
        callback = function() {};
    }

    SYS_FILES.get(id, function(err, model) {
        callback(err || !model ? false : model.getTexts());
    });
};
FilesApi.deleteFile = function(id, callback) {
    if ( !callback ) {
        callback = function() {};
    }
    SYS_FILES.get(id, function(err, deletedFileModel) {
        if ( err ) {
            return callback(err, []);
        }
        const deletedFileModelId = deletedFileModel.id;
        SYS_FILES.remove(deletedFileModelId, function(err, model) {
            callback(err, model);
        });
    });
};
// callback(err, model)
FilesApi.loadGlobalSystemFile = function(sysName, callback) {
    SYS_FILES.get({
        limit: 1,
        filter: SYS_FILES.Filter(["AND", "sysName", "glob"], {
            sysName: {
                type: "equal",
                key: "SYS_NAME",
                value: sysName
            },
            glob: {
                type: "equal",
                key: "IS_GLOBAL",
                value: 1
            }
        })
    },
    function(err, models) {
        let model;
        if ( models && models.length ) {
            model = models[0];
        }
        callback(err, model);
    });
};

FilesApi.checkMime = function(fileMime, acceptMime) {
    if ( !acceptMime ) { // acceptMime не указан, значит форма принимает все файлы
        return true;
    }
    if ( fileMime && f.isString(fileMime) && f.isString(acceptMime) ) {
        return acceptMime.search(fileMime) !== -1;
    }
    return false;
};

export default FilesApi;
